import React from 'react';
import classnames from 'classnames';
import { Button as AntdButton } from 'antd';
import { Link } from 'react-router-dom';

import { additionsClasses } from '../../../utils';

import style from './Button.module.scss';

export const Button = ({
  primary = false,
  vendorClass,
  additions = [],
  danger = false,
  success = false,
  disabled = false,
  to,
  children,
  id,
  text, ...props
}) => (to && !disabled
  ? (
    <Link
      data-testid={ id }
      to={ to }
      className={ classnames(style.Button, vendorClass, {
            [style.primary]: !disabled && primary,
            [style.danger]: !disabled && danger,
            [style.disabled]: disabled,
            [style.default]: !primary && !danger && !disabled
            },
            ...additionsClasses(additions, style),
            vendorClass) }
    >
      {children}
    </Link>
  )
  : (
    <AntdButton
      data-testid={ id }

      disabled={ disabled }
      className={ classnames(style.Button, vendorClass, {
    [style.primary]: !disabled && primary,
    [style.danger]: !disabled && danger,
    [style.success]: !disabled && success,
    [style.disabled]: disabled,
    [style.default]: !primary && !danger && !disabled
    },
    ...additionsClasses(additions, style),
    vendorClass) }

      { ...props }
    >
      <span className={ style.text }>{children || text}</span>
    </AntdButton>
  ));
